import RecordedTrigger from 'keyboard/RecordedTrigger.js';

class KeyboardRecordedTrigger {
    constructor(transpose, tracks, resolution, sequencerEngine, quantized, velocity=null) {
        //super(undefined, 0, resolution, sequencerEngine, quantized);
        this.sliceNumber = 0;
        this.recordedTriggers = tracks.map(
            track =>
                new RecordedTrigger(track, 0, resolution, sequencerEngine, quantized, velocity));
        this.transpose = transpose;
        this.tracks = tracks;
    }

    record(sequencerEngine, track, transpose) {
        this.recordedTriggers.map(
            (recordedTrigger, i) =>
                recordedTrigger.record(sequencerEngine, this.tracks[i], this.transpose + this.tracks[i].trackData.transpose));
    }
}

export default KeyboardRecordedTrigger;
